import React from "react";
import { useTranslation } from 'react-i18next';

import "./TrialPeriodExpiredModal.scss";

import TrialPeriodExpired from "static/icons/trial-period-expired.svg"
import UniversalButton from "../../uiComponents/UniversalButton";
import TrialMessageModal from "components/modals/TrialMessageModal";
import { useContext } from "react";
import { ModalContext } from "components/ModalContext";

const TrialPeriodExpiredModal = () => {
    const { t } = useTranslation();

    const { handleModal } = useContext(ModalContext);

    const onActionClick = () => {
        handleModal(<TrialMessageModal />);
    }

    return (
        <div className="trial-period-expired">
            <img
                className="trial-period-expired__img"
                src={TrialPeriodExpired}
            />

            <div className="trial-period-expired__content">
                <p className="trial-period-expired__content-title">
                    {t('trial_period_expired')}
                </p>

                <p className="trial-period-expired__content-text">
                    {t('dont_worry_your_work_hasnt_been_lost')}<br /><br />
                    {t('contact_us_to_continue')}<br /><br />
                </p>

                <div className="trial-period-expired__button-container">
                    <UniversalButton
                        label={t('get_in_touch')}
                        size="lg"
                        labelColor="white"
                        labelHoverColor="white"
                        backgroundColor="orange"
                        backgroundHoverColor="orange-light"
                        onClick={onActionClick}
                    />
                </div>
            </div>
        </div>
    );
};

export default TrialPeriodExpiredModal;
